export default __webpack_public_path__ + "static/icon-senr-376a4aedd0426ea721762d6acf787746.png";